import script from "./BaseTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplate.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplate.vue?vue&type=style&index=0&id=2d3182cc&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3182cc"]])

export default __exports__